// extracted by mini-css-extract-plugin
module.exports = {"tourProgress":"tourProgress--XAiyw","progressItem":"progressItem--1DpKl","progressBg":"progressBg--nzxmD","active":"active--1+FOc","completed":"completed--dEo2-"};